import { autoCapitalize } from '@/utils/autoCapitalize'
import { HolderHealthPlanData } from './HolderHealthPlanMapper.types'
import { formatCPF } from '@conexasaude/front-utils'

class HolderHealthPlanMapper {
  toDomain(persistenceData: HolderHealthPlanData) {
    return {
      id: persistenceData?.id,
      name: autoCapitalize(persistenceData?.nome),
      cpf: formatCPF(persistenceData.cpf || ''),
      cpfAndName: `${persistenceData?.cpf || ''} | ${autoCapitalize(
        persistenceData?.nome,
      )}`,
      cpfAndNameFmt: `${formatCPF(
        persistenceData.cpf || '',
      )} | ${autoCapitalize(persistenceData?.nome)}`,
    }
  }
}

export default new HolderHealthPlanMapper()
